"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseX = exports.Base58 = exports.Base32 = void 0;

var _bytes = require("@ethersproject/bytes");

var _properties = require("@ethersproject/properties");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var BaseX = /*#__PURE__*/function () {
  function BaseX(alphabet) {
    _classCallCheck(this, BaseX);

    (0, _properties.defineReadOnly)(this, "alphabet", alphabet);
    (0, _properties.defineReadOnly)(this, "base", alphabet.length);
    (0, _properties.defineReadOnly)(this, "_alphabetMap", {});
    (0, _properties.defineReadOnly)(this, "_leader", alphabet.charAt(0)); // pre-compute lookup table

    for (var i = 0; i < alphabet.length; i++) {
      this._alphabetMap[alphabet.charAt(i)] = i;
    }
  }

  _createClass(BaseX, [{
    key: "encode",
    value: function encode(value) {
      var source = (0, _bytes.arrayify)(value);

      if (source.length === 0) {
        return "";
      }

      var digits = [0];

      for (var i = 0; i < source.length; ++i) {
        var carry = source[i];

        for (var j = 0; j < digits.length; ++j) {
          carry += digits[j] << 8;
          digits[j] = carry % this.base;
          carry = carry / this.base | 0;
        }

        while (carry > 0) {
          digits.push(carry % this.base);
          carry = carry / this.base | 0;
        }
      }

      var string = ""; // deal with leading zeros

      for (var k = 0; source[k] === 0 && k < source.length - 1; ++k) {
        string += this._leader;
      } // convert digits to a string


      for (var q = digits.length - 1; q >= 0; --q) {
        string += this.alphabet[digits[q]];
      }

      return string;
    }
  }, {
    key: "decode",
    value: function decode(value) {
      if (typeof value !== "string") {
        throw new TypeError("Expected String");
      }

      var bytes = [];

      if (value.length === 0) {
        return new Uint8Array(bytes);
      }

      bytes.push(0);

      for (var i = 0; i < value.length; i++) {
        var byte = this._alphabetMap[value[i]];

        if (byte === undefined) {
          throw new Error("Non-base" + this.base + " character");
        }

        var carry = byte;

        for (var j = 0; j < bytes.length; ++j) {
          carry += bytes[j] * this.base;
          bytes[j] = carry & 0xff;
          carry >>= 8;
        }

        while (carry > 0) {
          bytes.push(carry & 0xff);
          carry >>= 8;
        }
      } // deal with leading zeros


      for (var k = 0; value[k] === this._leader && k < value.length - 1; ++k) {
        bytes.push(0);
      }

      return (0, _bytes.arrayify)(new Uint8Array(bytes.reverse()));
    }
  }]);

  return BaseX;
}();

exports.BaseX = BaseX;
var Base32 = new BaseX("abcdefghijklmnopqrstuvwxyz234567");
exports.Base32 = Base32;
var Base58 = new BaseX("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"); //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
//console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

exports.Base58 = Base58;